import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { AlunosRoutingModule } from './alunos-routing.module';
import { AlunosComponent } from './alunos.component';

@NgModule({
    declarations: [AlunosComponent],
    imports: [
        CommonModule,
        // Material modules
        MatCardModule,
        MatDividerModule,
        MatButtonModule,
        MatIconModule,
        SharedModule,
        AlunosRoutingModule,
        FormsModule,
        PipesModule,
    ],
    providers: [],
})
export class AlunosModule {}
